module.exports = __webpack_public_path__ + "static/salon-a2c12e6726904f4625bddce72c6ef9d0.jpg";